import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#684D9F',
    },
    secondary: {
      main: '#394F94',
      light: '#697CB5',
      dark: '#2A2D37',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 700,
      lg: 1280,
      xl: 1440,
    },
  },
  typography: {
    fontFamily: ['DM Sans'],
    fontSize: 12,
    fontStyle: 'normal',
    h1: {
      fontSize: 48,
      fontWeight: 'bold',
      lineHeight: '62px',
      letterSpacing: '-0.025em',
    },
    h2: {
      fontSize: 36,
      fontWeight: 'bold',
      lineHeight: '47px',
      letterSpacing: '-0.04em',
    },
    h3: {
      fontSize: 24,
      fontWeight: 'bold',
      lineHeight: '31px',
      letterSpacing: '-0.04em',
    },
    h4: {
      fontSize: 18,
      fontWeight: 'bold',
      lineHeight: '23px',
      letterSpacing: '-0.04em',
    },
    body1: {
      fontSize: 16,
      fontWeight: 'normal',
      lineHeight: '21px',
      letterSpacing: '-0.05em',
    },
  },
  overrides: {
    // MuiPaper: {
    //   root: {
    //     backgroundColor: 'transparent',
    //     width: '100%',
    //   },
    // },
    MuiAccordion: {
      root: {
        backgroundColor: 'transparent',
        paddingLeft: '10px',
        '&:before': {
          backgroundColor: 'transparent',
        },
        '&$expanded': {
          margin: '0px',
        },
      },
    },
    MuiAccordionSummary: {
      root: {
        minHeight: '100px',
      },
      content: {
        '&$expanded': {
          margin: '0px',
        },
      },
    },
    MuiAccordionDetails: {
      root: {
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
      },
    },
  },
});

export default theme;
